import { connect } from 'react-redux';

import { StoreState } from '../../../../../reducers';
import Slide from '../../../../../components/Editor/EditPanel/SliderManager/Slide';
import { getSliderPreviewUrl } from '../../../utils/helpers';
import { SlideData } from '../../../utils/indesignEditor/editableSliders/getData';

interface SlideOwnProps {
	page: number;
	sliderId: string;
	item: SlideData;
}

const mapStateToProps = (state: StoreState, ownProps: SlideOwnProps) => {
	const {
		editor: { editableSliders },
		galleryInfos: { config },
		importManager,
	} = state;

	const { page, sliderId, item } = ownProps;
	const { iconName, relUrl, externalRelUrl, isExternalLink } = item;
	const { importingSlides } = editableSliders[page][sliderId];
	const previewUrl = getSliderPreviewUrl(config, relUrl, isExternalLink, externalRelUrl, iconName);
	const importData = importManager.byId[item.id];

	return {
		page,
		previewUrl,
		isImporting: importingSlides.map(({ id }) => id).includes(item.id),
		importPercentage: importData ? importData.percentage : 0,
		importError: importData ? importData.error : undefined,
		isDragDisabled: importingSlides.length > 0,
	};
};

export default connect(mapStateToProps)(Slide);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/SliderPanel/Slide/index.tsx